'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var UtilsKeytrade = function UtilsKeytrade(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 34 28"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#03B3D9",
    fillRule: "nonzero",
    d: "M22.8 10.764l-1.532-2.613c-.245-.373-.062-.809.367-.871l10.052-1.867c.43-.062.98.187 1.165.623l.49 1.12a.788.788 0 0 1-.49 1.057L24.026 11.2c-.43.187-.98-.062-1.226-.436zM12.626 8.09l-1.532 2.675c-.246.374-.797.56-1.226.436L1.042 8.151c-.43-.187-.674-.622-.49-1.058l.49-1.12c.184-.373.674-.684 1.164-.622l10.052 1.867c.43.062.613.498.368.87zm5.884.56L28.623 25.51a.972.972 0 0 1-.184 1.245l-1.042.808c-.368.312-.858.25-1.103-.124l-8.888-12.569c-.306-.373-.735-.373-.98 0L7.539 27.44c-.245.373-.736.436-1.104.124l-1.041-.808c-.307-.312-.43-.872-.184-1.245L15.384 8.65c.184-.373.797-.685 1.226-.685h.674c.429 0 .98.312 1.226.685zm-.245-2.613h-2.759c-.429 0-.735-.374-.674-.81l.736-4.168c.122-.436.551-.81.98-.81h.675c.49 0 .919.374.98.81l.736 4.169c.061.435-.245.809-.674.809z"
  }));
};
var UtilsLoadingCircle = function UtilsLoadingCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-17)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "19",
    r: "18",
    fill: "#FFF",
    fillOpacity: "0",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeOpacity: "0",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    fillRule: "nonzero",
    d: "M37 19a1 1 0 0 1-2 0c0-9.388-7.612-17-17-17a1 1 0 0 1 0-2c10.492 0 19 8.508 19 19z"
  })));
};
var UtilsSpinner = function UtilsSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "3rem",
    height: "3rem",
    viewBox: "0 0 104 104",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spinner_KTB",
    fill: "#A7BDCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(72.000000, 17.358984) rotate(30.000000) translate(-72.000000, -17.358984) translate(68.000000, 5.358984)",
    fillOpacity: "0.9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(86.641016, 32.000000) rotate(60.000000) translate(-86.641016, -32.000000) translate(82.641016, 20.000000)",
    fillOpacity: "0.84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(92.000000, 52.000000) rotate(90.000000) translate(-92.000000, -52.000000) translate(88.000000, 40.000000)",
    fillOpacity: "0.76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(86.641016, 72.000000) rotate(120.000000) translate(-86.641016, -72.000000) translate(82.641016, 60.000000)",
    fillOpacity: "0.68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(72.000000, 86.641016) rotate(150.000000) translate(-72.000000, -86.641016) translate(68.000000, 74.641016)",
    fillOpacity: "0.6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.000000, 92.000000) rotate(180.000000) translate(-52.000000, -92.000000) translate(48.000000, 80.000000)",
    fillOpacity: "0.52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 86.641016) rotate(-150.000000) translate(-32.000000, -86.641016) translate(28.000000, 74.641016)",
    fillOpacity: "0.44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.358984, 72.000000) rotate(-120.000000) translate(-17.358984, -72.000000) translate(13.358984, 60.000000)",
    fillOpacity: "0.36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 52.000000) rotate(-90.000000) translate(-12.000000, -52.000000) translate(8.000000, 40.000000)",
    fillOpacity: "0.28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.358984, 32.000000) rotate(-60.000000) translate(-17.358984, -32.000000) translate(13.358984, 20.000000)",
    fillOpacity: "0.2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 17.358984) rotate(-30.000000) translate(-32.000000, -17.358984) translate(28.000000, 5.358984)",
    fillOpacity: "0.12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })))));
};
var LoaderLogo = function LoaderLogo(_ref) {
  var size = _ref.size,
    margin = _ref.margin;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    size: size || '6rem',
    margin: margin
  }, /*#__PURE__*/React.createElement(StyledLoader, null, /*#__PURE__*/React.createElement(UtilsLoadingCircle, {
    size: size || '6rem'
  })), /*#__PURE__*/React.createElement(UtilsKeytrade, {
    size: size || '6rem'
  }));
};
var StyledWrapper = styled.div.withConfig({
  displayName: "LoaderLogo__StyledWrapper",
  componentId: "sc-1ktzbx3-0"
})(["margin:", ";position:relative;display:inline-block;height:", ";width:", ";> *{flex:0 0 auto;}> *:last-child{display:block;position:absolute;z-index:2;top:50%;left:50%;width:calc(", " - 30%);transform:translate(-50%,-50%);}"], function (props) {
  return props.margin;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var StyledLoader = styled.div.withConfig({
  displayName: "LoaderLogo__StyledLoader",
  componentId: "sc-1ktzbx3-1"
})(["width:100%;height:100%;display:flex;justify-content:flex-end;svg{display:block;width:50%;height:50%;}@keyframes rotate{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}animation:rotate 1s linear infinite;"]);
var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var LoaderSpinner = function LoaderSpinner(_ref) {
  var label = _ref.label,
    margin = _ref.margin;
  return /*#__PURE__*/React.createElement(StyledWrapper$1, {
    margin: margin
  }, label && /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(UtilsSpinner, null));
};
var StyledWrapper$1 = styled.div.withConfig({
  displayName: "LoaderSpinner__StyledWrapper",
  componentId: "sc-8ucjug-0"
})(["margin:", ";@keyframes rotate{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}display:inline-block;span{display:block;color:", ";font-family:", ";text-transform:uppercase;font-size:1.4rem;padding-bottom:1rem;}svg{display:block;margin:0 auto;height:3rem;width:3rem;animation:rotate 0.8s steps(12,end) infinite;}:not(:first-child){padding-top:1rem;}"], function (props) {
  return props.margin;
}, colors.BlueCloudy, function (props) {
  return getFont(props.theme, 'semiBold');
});
LoaderSpinner.defaultProps = {
  label: null
};
exports.LoaderLogo = LoaderLogo;
exports.LoaderSpinner = LoaderSpinner;